import {useEffect} from 'react'

type DomainStyle = {
  colors: {
    titles: string
    cta: string
    background: string
    buttons: string
  }
  logo: string //base64 encoded SVG
}

export const useCustomStyle = () => {
  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      if (e.data.type === 'customeStyle') {
        document.getElementById('custom-style-color-picker')?.remove()
        const style = document.createElement('style')
        style.id = 'custom-style-color-picker'
        style.innerHTML = customStyleToCSS(e.data.payload)
        document.head.appendChild(style)

        Array.from(document.querySelectorAll('.domain_logo')).forEach((logoParent) => {
          logoParent.querySelector('svg:not(.absolute)')?.remove()
          logoParent.querySelector('span')?.remove()

          const div = document.createElement('div')
          div.innerHTML = atob(e.data.payload.logo)
          div.children[0].setAttribute('width', '64px')
          div.children[0].setAttribute('height', 'auto')
          logoParent.appendChild(div.children[0])

          const span = document.createElement('span')
          span.innerText = e.data.payload.title
          logoParent.appendChild(span)
        })
      }
    }
    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])
}

const customStyleToCSS = (customStyle: DomainStyle): string => {
  return `
/* Titles */

.commons_appbar_bg,
.commons_footer_bg,
.homepage_rank_banner_bg,
.homepage_toprated_button:hover,
.homepage_content_divider {
	background-color: ${customStyle.colors.titles} !important;
}

.homepage_toprated_button,
.homepage_did_you_know_cta,
.listpage_badge_winner_divider>p,
.listpage_badge_best_value_divider>p,
.listpage_button_new_layout_secondary,
.homepage_categories_card_border,
.homepage_button_secondary,
.listpage_button_secondary {
	border-color: ${customStyle.colors.titles} !important;
}

.listpage_badge_placement_text,
.listpage_badge_winner_text,
.listpage_badge_winner_divider,
.listpage_badge_best_value_divider,
.listpage_badge_score_text,
.listpage_button_new_layout_secondary,
.listpage_badge_editors_choice_text,
.listpage_button_secondary {
	color: ${customStyle.colors.titles} !important;
}

.listpage_badge_editors_choice_icon_stroke,
.listpage_button_new_layout_secondary path {
	stroke: ${customStyle.colors.titles} !important;
}

.listpage_widgets_recommended_products path,
.homepage_widgets_recommended_products path,
.listpage_widgets_specs_checked_icon path,
.listpage_button_new_layout_secondary path {
	fill: ${customStyle.colors.titles} !important;
}


/* CTA Color */

.listpage_button_primary,
.homepage_button_primary,
.listpage_button_new_layout_primary
 {
	background-color: ${customStyle.colors.cta} !important;
}

.listpage_button_link,
.listpage_button_new_layout_link {
	color: ${customStyle.colors.cta} !important;
}

.listpage_button_secondary path,
.listpage_button_new_layout_link path,
.listpage_widgets_specs_accordion_button_bg path {
	fill: ${customStyle.colors.cta} !important;
	stroke: ${customStyle.colors.cta} !important;
}

.listpage_button_icon_fill,
.listpage_button_new_layout_icon_fill {
	fill: ${customStyle.colors.cta} !important;
}

.listpage_button_icon_stroke,
.listpage_button_new_layout_icon_stroke {
	stroke: ${customStyle.colors.cta} !important;
}


/* Background Color */

.listpage_user_value_badge,
.listpage_badge_placement_bg,
.listpage_badge_best_value_bg,
.listpage_badge_winner_bg,
.listpage_badge_cta_discount_bg,
.homepage_did_you_know_bg,
.listpage_badge_cta_marketplace_logo_bg,
.listpage_widgets_recommended_products,
.homepage_widgets_recommended_products,
.listpage_widgets_specs_accordion_button_bg {
	background-color: ${customStyle.colors.background} !important;
}

.listpage_widgets_specs_checked_icon circle {
	fill: ${customStyle.colors.background} !important;
}


/* Buttons */

.listpage_badge_sponsored_bg,
.listpage_badge_card_discount_bg,
.homepage_on_sale_cta,
.listpage_badge_card_discount_old_bg,
.listpage_button_arrow_bg,
.homepage_button_arrow_bg,
.listpage_button_new_layout_arrow_bg {
	background-color: ${customStyle.colors.buttons} !important;
}

/* Defaults */ 
.listpage_badge_card_discount_old_text,
.homepage_on_sale_cta,
.listpage_badge_card_discount_bg {
  color: #FFFFFF !important;
}
`
}
